module.exports = __webpack_public_path__ + "i18n/zh-TW.95757a66d1208c1105c9b04a370048f0.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-TW.json
// module id = 1317
// module chunks = 59